// Token 存储 + 工具方法
// 单一来源：localStorage 的 `auth_token` 字段

const TOKEN_KEY = 'auth_token';
const USER_KEY = 'auth_user';

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || '';
  } catch (e) {
    return '';
  }
}

export function setToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch (e) { /* localStorage 不可用时静默 */ }
}

export function getUser() {
  try {
    return localStorage.getItem(USER_KEY) || '';
  } catch (e) {
    return '';
  }
}

export function setUser(user) {
  try {
    if (user) localStorage.setItem(USER_KEY, user);
    else localStorage.removeItem(USER_KEY);
  } catch (e) { /* noop */ }
}

export function clearAuth() {
  setToken('');
  setUser('');
}

export function isLoggedIn() {
  return !!getToken();
}
